import { DurationInputField } from '@mews-commander/form';
import { lt } from '@mews/framework';
import { Grid } from '@optimus-web/core';
import { ContentSection } from '@mews-commander/ui';
import { CancellationPolicyFormField } from '../types';
import { ApplicabilitySelectField, OffsetTypeSelectField } from './fields';

export const CancellationPolicyDeadlineFormSection = () => (
    <ContentSection title={lt('Deadline')}>
        <Grid templateColumns="2fr 1fr" gap="100">
            <DurationInputField
                name={CancellationPolicyFormField.ApplicabilityOffset}
                units={{ days: true, hours: true }}
                required
            />
            <OffsetTypeSelectField />
        </Grid>
        <ApplicabilitySelectField />
    </ContentSection>
);
